type PerfEntryReporter = (metric: unknown) => void;

const reportWebVitals = (onPerfEntry?: PerfEntryReporter) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    void import('web-vitals').then((webVitals) => {
      const wv = webVitals as Record<string, unknown>;

      const onCLS = wv.onCLS as ((cb: PerfEntryReporter) => void) | undefined;
      const onFCP = wv.onFCP as ((cb: PerfEntryReporter) => void) | undefined;
      const onINP = wv.onINP as ((cb: PerfEntryReporter) => void) | undefined;
      const onLCP = wv.onLCP as ((cb: PerfEntryReporter) => void) | undefined;
      const onTTFB = wv.onTTFB as ((cb: PerfEntryReporter) => void) | undefined;

      const getCLS = wv.getCLS as ((cb: PerfEntryReporter) => void) | undefined;
      const getFCP = wv.getFCP as ((cb: PerfEntryReporter) => void) | undefined;
      const getFID = wv.getFID as ((cb: PerfEntryReporter) => void) | undefined;
      const getLCP = wv.getLCP as ((cb: PerfEntryReporter) => void) | undefined;
      const getTTFB = wv.getTTFB as ((cb: PerfEntryReporter) => void) | undefined;

      if (onCLS && onFCP && onLCP && onTTFB) {
        onCLS(onPerfEntry);
        onFCP(onPerfEntry);
        if (onINP) onINP(onPerfEntry);
        onLCP(onPerfEntry);
        onTTFB(onPerfEntry);
        return;
      }

      if (getCLS && getFCP && getLCP && getTTFB) {
        getCLS(onPerfEntry);
        getFCP(onPerfEntry);
        if (getFID) getFID(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
      }
    });
  }
};

export default reportWebVitals;
